import React, { useState } from "react"
import PropTypes from "prop-types"
// import {Link} from 'gatsby'
import { Box, Button, HStack, Link, Text, VStack, useDisclosure, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Modal, Image, Center } from "@chakra-ui/react"
import Widgets from "./widgets"

const SustainabilityScore = ({ score, isDesign = false }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [showWidget, setShowWidget] = useState(true)

    function hideWidget() {
        setShowWidget(false)
    }

    console.log("showWidget", showWidget)
    return (
        <>
            {!isDesign &&
                <Box width={['400px', '380px', '320px', '380px']} maxW="100%" >
                    
                        <VStack width='100%'>
                            <Box width='100%'>
                                {/* <Text variant={"scoreHeading"} >Footprint Savings</Text> */}
                                <Text variant={"scoreText"}>Compared to a conventional product made of new materials, this product saves you the following.</Text>
                            </Box>
                            <Link onClick={onOpen} width='100%'>
                                <Widgets score={score} hideFunction={hideWidget} />
                            </Link>
                            <Box width='100%'>
                                <Link isExternal target="_blank" href="https://www.dayrize.io" alt='Dayrize verified scores'>Verified by <b>Dayrize</b></Link>
                            </Box>
                        </VStack>                    
                    <Modal isOpen={isOpen} onClose={onClose} size={['xs', 'lg', '2xl', '4xl']} borderRadius={'unset'}>
                        <ModalOverlay />
                        <ModalContent borderRadius={'unset'}>
                            <ModalCloseButton top={0} right={0}
                                _hover={{
                                    background: 'none'
                                }}
                                _focus={{
                                    boxShadow: 'none'
                                }} />
                            <ModalBody margin={0} padding={0} max-

                            >
                                <Image
                                    alt="Dayrize Score"
                                    src={`/sustainability/${score}/score.jpg`}
                                />
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </Box>
            }
        </>
    )
}

export default SustainabilityScore

SustainabilityScore.propTypes = {
    score: PropTypes.string.isRequired
}

